import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import './firebase'
import { RouterProvider } from 'react-router-dom'
import { router } from './routes'
import { UserProvider } from 'context/user'
import reportWebVitals from './reportWebVitals'
import { SnackbarProvider } from 'notistack'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <React.StrictMode>
    <SnackbarProvider>
      <UserProvider>
        <RouterProvider router={router} />
      </UserProvider>
    </SnackbarProvider>
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
